import { register } from "@rill/loader";
import moment from "moment";
import { isAfterToday } from "../utils/date-helpers";

register(
  {
    name: "dailyStats",
    meta: ["no-bust", "daily-stats"],
    ttl: "2 hours",
  },
  async ({ api }, { proxyAthlete, start, end, date }) => {
    if (date && isAfterToday(date)) return [];
    const targetQuery = {
      query: {
        limit: false,
        proxyAthlete,
      },
    };
    if (start && end) {
      targetQuery.query.utcDate = {
        $gte: parseInt(moment.utc(start).format("YYYYMMDD")),
        $lte: parseInt(moment.utc(end).format("YYYYMMDD")),
      };
    }
    if (date) {
      targetQuery.query.utcDate = parseInt(moment.utc(date).format("YYYYMMDD"));
    }
    const res = await api("daily-stats", targetQuery);
    const jsonRes = await res.json();
    return jsonRes;
  }
);
